<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1619_32422)">
      <g clip-path="url(#clip1_1619_32422)">
        <path
          d="M1.25 14.25L4.5 17.5L7.74999 14.25"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.56879 19.1813C10.1243 19.9263 11.8797 20.1456 13.5707 19.8061C15.2616 19.4667 16.7965 18.5869 17.9439 17.2993C19.0914 16.0117 19.7893 14.386 19.9325 12.6673C20.0757 10.9486 19.6565 9.22985 18.7379 7.77011C17.8194 6.31037 16.4513 5.18869 14.8399 4.57407C13.2284 3.95945 11.4609 3.88518 9.80354 4.36247C8.14621 4.83976 6.68889 5.84274 5.65116 7.2203C4.61342 8.59785 4.05149 10.2753 4.05003 12L4.50004 17"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <path
        d="M12 8V12.5L16 14"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1619_32422">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_1619_32422">
        <rect
          width="21.2132"
          height="21.2132"
          fill="white"
          transform="translate(-3 12) rotate(-45)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
